import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import request, { type ResponseError } from 'superagent';

export type ForgotPasswordPayload = {
  email: string;
};

/**
 * Requests a set/reset password email for a local account.
 * The gateway always returns 204 so that account existence is not leaked.
 * @returns TanStack Query mutation that posts to `/auth/local/forgot-password`.
 */
export const useForgotPassword = (): UseMutationResult<
  void,
  ResponseError,
  ForgotPasswordPayload
> => {
  return useMutation({
    mutationFn: async ({ email }: ForgotPasswordPayload): Promise<void> => {
      await request
        .post('/auth/local/forgot-password')
        .send({ email })
        .set('Content-Type', 'application/json')
        .withCredentials();
    },
  });
};
